import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { publicAreaRoutes } from './modules/public-area/public-area-routing.module';
import { privateAreaRoutes } from './modules/private-area/private-area-routing.module';
import { testRoutes } from './submodules/test-pages/test-routing.module';
import { RoutingGuardService } from './submodules/angular-common/routing-guard.service';

const routes: Routes = [
    { path: '', children: [...publicAreaRoutes], pathMatch: 'full' },
    // -> LAZY LOADING WAY (non funziona su electron)
    { path: 'private', loadChildren: () => import('./modules/private-area/private-area.module').then(m => m.PrivateAreaModule) },
    // -> EAGER LOADING WAY (unica possibilità su electron)
    //{ path: 'private', children: [...privateAreaRoutes], canActivate:[RoutingGuardService]},
    // -> PAGINE DI TEST
    // -> LAZY LOADING WAY (non funziona su electron)
    { path: 'test', loadChildren: () => import('./submodules/test-pages/test.module').then(m => m.TestModule) }
    // -> EAGER LOADING WAY (unica possibilità su electron)
    //{ path: 'test', children: [...testRoutes]},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy',
                                             scrollPositionRestoration: 'enabled',
                                             anchorScrolling: 'enabled',
                                             scrollOffset: [0, 110],
                                             enableTracing: false
                                            })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
